import { Box, Typography, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface Props {
    value: number;
    onChange: (depth: number) => void;
    disabled?: boolean;
}

const DEPTH_DESCRIPTIONS: Record<number, string> = {
    1: 'Свои цепочки + прямые рефералы',
    2: 'Рефералы (только клоны) + их рефералы',
    3: 'Рефералы рефералов (клоны) + их рефералы',
    4: 'Глубина 4',
    5: 'Глубина 5',
    6: 'Глубина 6',
    7: 'Глубина 7',
    8: 'Глубина 8',
    9: 'Глубина 9',
    10: 'Глубина 10',
};

export const DepthSelector = ({ value, onChange, disabled }: Props) => {
    const theme = useTheme();
    const primaryColor = theme.palette.primary.main;

    return (
        <Box>
            <Typography
                variant="h6"
                sx={{ color: 'text.secondary', fontWeight: 400, mb: 1 }}
            >
                Глубина
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={0.5}>
                {Array.from({ length: 10 }, (_, i) => i + 1).map((d) => {
                    const active = d === value;
                    return (
                        <Tooltip
                            key={d}
                            title={DEPTH_DESCRIPTIONS[d] ?? `Глубина ${d}`}
                            placement="top"
                            arrow
                        >
                            <button
                                onClick={() => !disabled && onChange(d)}
                                disabled={disabled}
                                style={{
                                    cursor: disabled ? 'not-allowed' : 'pointer',
                                    width: 36,
                                    height: 36,
                                    borderRadius: 6,
                                    border: `1px solid ${active ? primaryColor : `${primaryColor}40`}`,
                                    backgroundColor: active ? primaryColor : 'transparent',
                                    color: active ? '#fff' : primaryColor,
                                    fontWeight: 'bold',
                                    fontSize: 14,
                                    transition: 'all 0.15s',
                                    opacity: disabled ? 0.5 : 1,
                                }}
                            >
                                {d}
                            </button>
                        </Tooltip>
                    );
                })}
            </Box>
        </Box>
    );
};